import PaginatorCollection from 'component/paginator/collection/paginator'
import GroupModel from 'component/teaser_group/model/teaser_group'

export default PaginatorCollection.extend({
    model: GroupModel,
})
